import { render, staticRenderFns } from "./DeleteTransactionsPage.vue?vue&type=template&id=1e96293d&scoped=true&"
import script from "./DeleteTransactionsPage.vue?vue&type=script&lang=ts&"
export * from "./DeleteTransactionsPage.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteTransactionsPage.vue?vue&type=style&index=0&id=1e96293d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e96293d",
  null
  
)

export default component.exports